import React from 'react';
import { Router } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import { SnackbarProvider } from 'notistack';
import { Provider as StoreProvider } from 'react-redux';
import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles';
import DateAdapter from '@mui/lab/AdapterMoment';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import { renderRoutes } from 'react-router-config';
import jwt from 'jwt-decode';
import { DateEnv } from '@fullcalendar/core';
import config from 'configuration/configuration.js';
import theme from './theme';
import { configureStore } from './store';
import routes from './routes';
import { getUserInfo } from './actions';
import { Loading, ScrollReset, GoogleAnalytics, CookiesNotification } from './components';
import Notifier from './components/Notifier/Notifier';
import './mixins/chartjs';
import './mixins/moment';
import './mixins/validate';
import './mixins/prismjs';
import './mock';
import './assets/scss/index.scss';

import { interceptor } from './utils/AxiosRequest';

const history = createBrowserHistory({ basename: process.env.PUBLIC_URL });
const store = configureStore();
interceptor(store);

const App = () => {
	const token = localStorage.getItem(config.TOKEN_KEY);
	if (token) {
		const decoded = jwt(token);
		const currentDate = new Date().getTime() / 1000;
		if (decoded.exp > currentDate) {
			store.dispatch(getUserInfo(token));
		}
	}
	return (
		<StoreProvider store={store}>
			<StyledEngineProvider injectFirst>
				<ThemeProvider theme={theme}>
					<SnackbarProvider maxSnack={3} autoHideDuration={4000} anchorOrigin={{ vertical: 'bottom', horizontal: 'right', }}>
						<LocalizationProvider dateAdapter={DateAdapter}>
							<Router history={history}>
								<ScrollReset />
								<Loading />
								{/* <GoogleAnalytics /> */}
								<CookiesNotification />
								{renderRoutes(routes)}
								<Notifier />
							</Router>
						</LocalizationProvider>
					</SnackbarProvider>
				</ThemeProvider>
			</StyledEngineProvider>
		</StoreProvider>
	);
};

export default App;
